import { PopupTable } from './PopupTable'
import { withPopupTable } from './withPopupTable'

const ConnectedPopupTable = withPopupTable(PopupTable)

export { ConnectedPopupTable as PopupTable }
